module.exports = __webpack_public_path__ + "static/media/loyaltyIcon.53fab719.svg";